import { useRef } from 'react'

/**
 * True from the first time it is told so, and true from then on.
 *
 * A list that has been asked for stays asked for. Nothing in this package sets
 * a stale time, so turning a query off and on again — closing the panel and
 * opening it once more — would read the same list a second time.
 */
export const useOnceTrue = (value: boolean): boolean => {
  const wasTrue = useRef(false)
  if (value) wasTrue.current = true
  return wasTrue.current
}
